import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { AppContextProvider } from './app/contexts/AppContext';
import { AuthContextProvider } from './app/contexts/AuthContext';

const App = () => {
  console.log("REACT_APP_PANEL:", process.env);
  return (
    <BrowserRouter basename='/'>
      <AuthContextProvider>
        <AppContextProvider>
          <AppRoutes />
        </AppContextProvider>
      </AuthContextProvider>
    </BrowserRouter>
  );
};

export default App;
